<div class="modal fade" tabindex="-1" role="dialog" id="pecas-atendidas-filtro">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 translate class="modal-title">{{'parametros.pecaAtendida.filtros.definirFiltros'}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container striped-rows">
          <div class="row ptb5">
            <div translate class="col col-4">
              Dealer
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="number" [(ngModel)]="Dealer">
                <option translate value="">{{'parametros.pecaAtendida.filtros.dealerPlaceHolder'}}</option>
                <option *ngFor="let item of dealers" [value]="item.id">{{item.descricao}}</option>
              </select>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'parametros.pecaAtendida.filtros.mes'}}
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="number" [(ngModel)]="Mes">
                <option translate value="">{{'parametros.pecaAtendida.filtros.mesPlaceHolder'}}</option>
                <option translate value="1">{{'rmpv.analiseVenda.filtros.meses.janeiro'}}</option>
                <option translate value="2">{{'rmpv.analiseVenda.filtros.meses.fevereiro'}}</option>
                <option translate value="3">{{'rmpv.analiseVenda.filtros.meses.marco'}}</option>
                <option translate value="4">{{'rmpv.analiseVenda.filtros.meses.abril'}}</option>
                <option translate value="5">{{'rmpv.analiseVenda.filtros.meses.maio'}}</option>
                <option translate value="6">{{'rmpv.analiseVenda.filtros.meses.junho'}}</option>
                <option translate value="7">{{'rmpv.analiseVenda.filtros.meses.julho'}}</option>
                <option translate value="8">{{'rmpv.analiseVenda.filtros.meses.agosto'}}</option>
                <option translate value="9">{{'rmpv.analiseVenda.filtros.meses.setembro'}}</option>
                <option translate value="10">{{'rmpv.analiseVenda.filtros.meses.outubro'}}</option>
                <option translate value="11">{{'rmpv.analiseVenda.filtros.meses.novembro'}}</option>
                <option translate value="12">{{'rmpv.analiseVenda.filtros.meses.dezembro'}}</option>
              </select>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'parametros.pecaAtendida.filtros.ano'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="number" placeholder="{{'parametros.pecaAtendida.filtros.anoPlaceHolder' | translate}}" [(ngModel)]="filtros.ano">
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'parametros.pecaAtendida.filtros.quantidade'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="number" placeholder="{{'parametros.pecaAtendida.filtros.quantidadePlaceHolder' | translate}}" [(ngModel)]="filtros.valor">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="limparFiltros()">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>
</div>